module.exports = __webpack_public_path__ + "files/381681d677e765f4fe4b9b439c32053c.png";